@for (file of getFilesById(); track $index) {
  <app-file-card
    [fileCard]="{
      id: file.id,
      fileParams: file.file,
      fileType: turnkeyCostFileType(),
      isEditModeActive: isEditModeActive(),
      shouldCheckImageType: false
    }"
    (handleDelete)="handleDelete($event, file)"
  />
}
<app-file-upload-card
  [fileUploadParams]="{
    parentId: turnkeyCostId(),
    recordId: turnkeyCostId(),
    type: `${turnkeyCostFileType()}-${turnkeyCostId()}`,
    entityFileType: turnkeyCostFileType()
  }"
  [isEditModeActive]="isEditModeActive()"
  (attachFile)="attachFile($event)"
/>
